const keyPrefix = 'webclip';
type KeyType =
  | 'token'
  | 'iphone_uid'
  | 'iphone_registration_token'
  | 'configuration_profile_install_token'
  | 'configuration_profile_re_install';

export class Storage {
  private static get storage(): globalThis.Storage | null {
    try {
      return window.localStorage;
    } catch {
      return null;
    }
  }

  static async get(keyType: KeyType): Promise<string | null> {
    const storage = this.storage;
    if (!storage) return null;

    const dataString = storage.getItem(this.key(keyType));
    if (dataString === null) {
      return null;
    }

    try {
      const data = JSON.parse(dataString);
      const expiredDate = data['expiredDate']
        ? new Date(data['expiredDate'])
        : null;

      if (expiredDate === null || new Date() < expiredDate) {
        return data['value'];
      }
    } catch {
      this.delete(keyType);
      return null;
    }

    this.delete(keyType);
    return null;
  }

  static async save(
    keyType: KeyType,
    value: string,
    expiredDate?: Date
  ): Promise<void> {
    const storage = this.storage;
    if (!storage) return;

    const data: { [key: string]: string | number } = {
      value,
    };
    if (expiredDate) {
      data['expiredDate'] = expiredDate.getTime();
    }

    storage.setItem(this.key(keyType), JSON.stringify(data));
  }

  static async delete(keyType: KeyType): Promise<void> {
    const storage = this.storage;
    if (!storage) return;
    storage.removeItem(this.key(keyType));
  }

  static async clear(): Promise<void> {
    const storage = this.storage;
    if (!storage) return;
    storage.clear();
  }

  private static key(keyType: KeyType): string {
    return `${keyPrefix}-${keyType}`;
  }
}
